import { getCountryIsoByIp } from '~/utils/maxmind';

export default defineNuxtRouteMiddleware(async (to) => {
    if (import.meta.client && to.path === '/') {
        const existingLocation = [
            'ar',
            'au',
            'at',
            'al',
            'be',
            'ba',
            'br',
            'bg',
            'ca',
            'cl',
            'cz',
            'ch',
            'de',
            'dk',
            'ee',
            'es',
            'fr',
            'fi',
            'hr',
            'ir',
            'is',
            'it',
            'ie',
            'jp',
            'lv',
            'lt',
            'lu',
            'mx',
            'nl',
            'nz',
            'pl',
            'pt',
            'si',
            'sk',
            'se',
            'rs',
            'tr',
            'uk',
            'us',
            'za',
        ];

        let userLocation: any;
        try {
            userLocation = JSON.parse(localStorage.userLocation);
        } catch (e) {
            userLocation = {};
        }

        if (!userLocation || !userLocation.location || new Date().getTime() > userLocation.expired) {
            const res = await $fetch('/api/user-country');
            if (res) {
                const expired = new Date();
                expired.setDate(expired.getDate() + 1);
                const countryRes = res.country?.country;
                const countryIso =
                    countryRes?.iso_code?.toLowerCase() === 'gb' ? 'uk' : countryRes?.iso_code?.toLowerCase();
                userLocation = { location: countryIso, expired: expired.getTime() };
                localStorage.setItem('userLocation', JSON.stringify(userLocation));
            }
        }

        const userCountry = userLocation.location;
        if (userCountry && existingLocation.includes(userCountry)) {
            return navigateTo(`/${userCountry}`, { external: true });
        }
    }
});
